import { privateRoot, rotaAtendente } from 'routes/paths';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';

export const getRotaVoltar = user => {
  if (user?.profile === ENUM_TIPO_PERFIL.ATENDENTE) {
    return rotaAtendente;
  }
  if (user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR || user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL) {
    return privateRoot;
  }
  return '';
};
